import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../environments/environment.development";
@Injectable({ providedIn: "root" })
export class ApiClient {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}`; // '/api';
  get<T>(path: string, headers?: HttpHeaders) {
    return this.http.get<T>(`${this.baseUrl}${path}`, { headers });
  }
  post<T>(path: string, body: any, headers?: HttpHeaders) {
    return this.http.post<T>(`${this.baseUrl}${path}`, body, { headers });
  }
  put<T>(path: string, body: any, headers?: HttpHeaders) {
    return this.http.put<T>(`${this.baseUrl}${path}`, body, { headers });
  }
  delete<T>(path: string, headers?: HttpHeaders) {
    return this.http.delete<T>(`${this.baseUrl}${path}`, { headers });
  }
}
